<template>
    <main-content v-if="$can('manage-black-list', 'security')">
        <kt-panel class="no-mb">
            <kt-panel-header >
                <kt-panel-header-toolbar >
                    <ul class="nav nav-pills" role="tablist">
                        <li class="nav-item">
                            <a class="nav-link active" data-toggle="tab" href="#search_ips" aria-selected="false">
                                {{ $t('security.search') }}
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" data-toggle="tab" href="#suspected_ips" aria-selected="false">
                                {{ $t('security.suspected-IPs') }}
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" data-toggle="tab" href="#black_ips" aria-selected="false">
                                {{ $t('security.black-IPs') }}
                            </a>
                        </li>
                    </ul>
                </kt-panel-header-toolbar>
            </kt-panel-header>
        </kt-panel>
            <kt-panel-body>
                <div class="tab-content">
                    <div class="tab-pane active" id="search_ips">
                        <search-ips></search-ips>
                    </div>
                    <div class="tab-pane" id="suspected_ips">
                        <suspected-ips></suspected-ips>
                    </div>
                    <div class="tab-pane" id="black_ips">
                        <black-ips></black-ips>
                    </div>
                </div>
            </kt-panel-body>
    </main-content>
</template>

<script>
    import mainContent from '@/components/main-content'
    import searchIPs from './components/search-ips'
    import suspectedIPs from './components/suspected-ips'
    import blackIPs from './components/black-ips'

    export default {
        name: 'security-search-IPs',
        components: {
            'main-content': mainContent,
            'search-ips': searchIPs,
            'suspected-ips': suspectedIPs,
            'black-ips': blackIPs,
        },
    }
</script>

<style>

    .no-mb{
        margin-bottom: 0.1rem !important;
    }
    .kt-nav {
        padding-top: 0 !important;
        padding-bottom: 0.5rem !important;
    }

</style>